module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921022649_T.cc349617.jpg";